module.exports = __webpack_public_path__ + "static/media/login-logo.ef902ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login-logo.png
// module id = 870
// module chunks = 0